import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import NotFoundPage from '../sellers_module/components/not_found/not_found_page';
import '../../src/audience_module/shiprocket_audience.scss'
import { audience_icon, rectangleFrame, f1, f2, f3, tabtop } from "../assets"
import AudiencePopUp from './popup_model/audience_popup';
import { toast, ToastContainer } from 'react-toastify';
import AudienceRedirect from '../sellers_module/components/audience_redirect';
import { audienceContactUs, checkAudienceData, tokenverfy } from '../sellers_module/services/seller/api';
import srIcon from '../assets/srIcon.svg';
import { setIsActive } from '../sellers_module/store/slice/audience_activate';
import { Button, CircularProgress } from '@mui/material';
import { Spinner } from '@shopify/polaris';
import { captureGAEvent } from '../sellers_module/shared/helper';
import { clearEvents } from '../sellers_module/utils/changeHeaderColor';
import AudienceFaqs from './audience_faqs/audience_faqs';
import { audienceFbConnectSucess } from '../sellers_module/services/seller/api';

import { Helmet } from "react-helmet";
import { Message } from '@mui/icons-material';
import { loggedIn } from '../sellers_module/store/slice/authSlice';
interface Option {
    value: string;
    label: string;
}
export default function AudiencePage() {

    const auth = useSelector((state: any) => state.auth);
    const is_active = useSelector((state: any) => state.active.is_active);
    const [dialogOpen, setDialogOpen] = useState(false); // State to manage the dialog open/close
    const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);
    const dispatch = useDispatch();
    const [isLoading, setLoading] = useState(true);
    const faqsRef = useRef<HTMLDivElement | null>(null);
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const selectedAccountId = localStorage.getItem('selectedAudienceID') || null;
    const [selectedValue, setSelectedValue] = useState<string>('');
    const [isFbConnected, setIsFbConnected] = useState(false)
    const [options, setOptions] = useState<Option[]>([]);

    function generateFacebookAuthUrl(clientId, redirectUri, companyId) {
        const baseAuthUrl = 'https://www.facebook.com/v21.0/dialog/oauth?';
        const scope = 'ads_read,ads_management,business_management';

        // Combine data and companyId into the state parameter
        const stateObject = {
            companyId: companyId,
        };
        const state = encodeURIComponent(JSON.stringify(stateObject)); // Stringify and encode the state object

        const params = new URLSearchParams({
            client_id: clientId,
            scope: scope,
            state: state,
            redirect_uri: redirectUri
        });

        return baseAuthUrl + params.toString();
    }


    // Example usage=
    const clientId = process.env.REACT_APP_FACEBOOK_CLIENT_ID || "1311461483569831";
    const redirectUri = process.env.REACT_APP_WEB_BASE_URL + '/shiprocket_audience/product';
    const storedcompanyId = localStorage.getItem("company_id");
    const companyId = storedcompanyId;
    const facebookOAuthUrl = generateFacebookAuthUrl(clientId, redirectUri, companyId);
    console.log(clientId);
    console.log(facebookOAuthUrl);

    useEffect(() => {
        const selectedAudienceID = localStorage.getItem('selectedAudienceID');
        const accountsIDS = localStorage.getItem('accounts');

        // If either `selectedAudienceID` or `accounts` is null or empty, call `verifyToken` instantly
        if (!selectedAudienceID || !accountsIDS || accountsIDS === '[]') {
            console.log('Either selectedAudienceID or accounts is missing. Calling verifyToken...');
            verifyToken();
        }
        const apicheckAudience = async () => {
            try {
                setLoading(true);
                const res = await checkAudienceData();
                setIsFbConnected(res?.data?.is_connected)
                if (res.data.is_connected) {
                    localStorage.setItem('fbOauth', res.data.is_connected)
                    setLoading(false);
                } else {
                    localStorage.setItem('fbOauth', res.data.is_connected)
                }

                if (res.data.is_active) {
                    localStorage.setItem('activeAudience', res.data.is_active)
                    dispatch(setIsActive(true));
                    setLoading(false);
                    // toast.success("The status is active.");
                } else {
                    dispatch(setIsActive(false));
                    setLoading(false);
                    // toast.error("The status is inactive.");
                }


                // Handle successful response
            } catch (error: any) {
                setLoading(false);
                console.error("API call error:", error);


            }
        };
        apicheckAudience();  // You can pass necessary data if required for the API

    }, []);
    useEffect(() => {
        let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement | null;
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        if (link) {
            link.href = 'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727251368_file.png';
        }
    }, []);

    const verifyToken = async () => {
        const storedToken = localStorage.getItem('satellizer_token');
        const selectedAudienceID = localStorage.getItem('selectedAudienceID');
        if (!storedToken) {
            console.warn('No stored token found.');
            return;
        }
        const data = {
            token: storedToken,
            validate_token_request: 1,
        };
        try {
            // Call the API to verify the token
            const response = await tokenverfy(data);
            console.log('Token verification response:', response.data);
            const result = response.data.result || [];
            if (result.length === 0) {
                console.warn('No accounts found in the response.');
            }
            // Update Redux store
            dispatch(
                loggedIn({
                    userData: {
                        first_name: response.data.userData.first_name,
                        last_name: response.data.userData.last_name,
                        company_name: response.data.userData.company_name,
                        email: response.data.userData.email,
                    },
                    model: {
                        company_id: response.data.model.company_id,
                    },
                    result: result,
                    token: storedToken,
                })
            );
            // Generate account options
            const accountOptions = result.map((account) => {
                const cleanedAccountId = account.account_id.replace(/^act_/, '');
                const accountName = account.account_name || 'Unknown Account';
                return {
                    value: cleanedAccountId,
                    label: `Account id - ${cleanedAccountId} (${accountName})`,
                };
            });
            setOptions(accountOptions);
            // Save the first account ID if no selectedAudienceID is stored
            const firstAccountId = result.length > 0 ? result[0].account_id.replace(/^act_/, '') : '';
            const selectedValue = selectedAudienceID || firstAccountId;
            if (!selectedAudienceID && firstAccountId) {
                localStorage.setItem('selectedAudienceID', firstAccountId);
                console.log('Saved selectedAudienceID to localStorage:', firstAccountId);
            }
            setSelectedValue(selectedValue);

        } catch (error: any) {
            console.error('Error during token verification:', error.message);
            toast.error('Token verification failed. Please log in again.');
            // Clear local storage and log out on failure
            localStorage.clear();

        }
    };

    const apiContactUsApi = async () => {
        try {
            const data = {
                subject: "",
                message: ''
            }
            const res = await audienceContactUs(data);

            if (res.data.message) {


                toast.success(res.data.message);
            } else {


                toast.error("Somthing went wrong..");
            }


            // Handle successful response
        } catch (error: any) {

            toast.error(error);
            console.error("API call error:", error);


        }
    };

    useEffect(() => {
        // Function to check if the view is in tablet or mobile view
        const handleResize = () => {
            setIsMobileOrTablet(window.innerWidth <= 1024);
        };

        // Add event listener to window resize
        window.addEventListener('resize', handleResize);

        // Initial check
        handleResize();

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const handleClick = async () => {
        try {
            // Example API call (Replace with actual API URL)
            apiContactUsApi();
            console.log('API Response:', "response.data");
            // Do something with the response, like redirect or show a message
        } catch (error) {
            console.error('Error hitting the API:', error);
        }
    };


    const handleFaqClick = () => {
        if (faqsRef.current) {
            const yOffset = -80; // Optional: Offset to account for fixed header, adjust if necessary
            const yPosition = faqsRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;

            // Smoothly scroll to the position of the FAQ section
            window.scrollTo({
                top: yPosition,
                behavior: 'smooth',
            });
        } else {
            console.log("FAQ reference is not set or the element doesn't exist.");
        }
    };
    const handleOpenDialog = async () => {
        if (isFbConnected ) {
            window.location.href = "/shiprocket_audience/product";
        } else {
            window.location.href = facebookOAuthUrl;
        }
    };
    const sendGAEvent = (event: string) => {
        captureGAEvent(event, event);
    };
    const handleCloseDialog = () => {
        setDialogOpen(false); // Close the dialog when needed
    };

    const handleContactusError = (errorMessage) => {

        toast.error(errorMessage); // Show toast notification for the error
    };

    if (!auth.token) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <AudienceRedirect />
            </div>
        );
    }

    // Show the loading spinner while waiting for the audience data
    if (isLoading) {
        return (
            <div className='containerLoading' style={{ display: 'flex', justifyContent: 'center', paddingTop: '10%' }}>
                <Spinner size="large" />
            </div>
        );
    }
    return (
        <>
            <div >
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>{"Shiprocket AudiencePro"}</title>
                </Helmet>
                <div className='containerA'>
                    <div className=" bg-white">
                        <ToastContainer style={{ paddingTop: "50px" }} />
                        {!isMobileOrTablet ? (
                            <div className=" bg-white">

                                <div className="audienceTop">
                                    <div className="containerB">
                                        <div className="audienceHeader-bg flex justify-between items-center">
                                            <div className="pt-5 w-80  logo-container">
                                                <img src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1727165047_file.png'} alt="Shiprocket Icon" />
                                            </div>

                                            <div className="pt-7 pl-10 button-container">
                                                {<button
                                                    onClick={handleOpenDialog}
                                                    className="activate-button"
                                                >
                                                    <a
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{ textDecoration: "none", color: "inherit" }}
                                                    >
                                                        {selectedAccountId == null ? "Join for Free" : "Explore Audiences"}

                                                    </a>
                                                </button>}

                                            </div>
                                        </div>
                                        {/* <AudiencePopUp
                                            open={dialogOpen}
                                            onClose={handleCloseDialog}
                                            onError={handleContactusError} // Pass error handler
                                            setIsActive={(isActive) => dispatch(setIsActive(isActive))} // Pass down the dispatch function
                                        /> */}
                                    </div>
                                    <div className='pt-14 pl-16 w-1/2'>
                                        <div>
                                            <label style={{
                                                fontFamily: "sfprobold",
                                                color: "white",
                                                fontSize: "58px",
                                                background: 'linear-gradient(to right, #5bc78b 0%, #CACCD0 50%, #9577FF 100%)',
                                                WebkitTextFillColor: 'transparent',
                                                WebkitBackgroundClip: 'text',
                                            }}>
                                                Boost Your ROAS &nbsp;
                                            </label>
                                            <label style={{
                                                fontFamily: "sfprobold",
                                                color: "white",
                                                fontSize: "38px",
                                                background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                                                WebkitTextFillColor: 'transparent',
                                                WebkitBackgroundClip: 'text',
                                            }}>
                                                {/* {"AI Tailored Audiences "} */}
                                            </label>
                                            {/* <Button style={{
                                                marginBottom: "2%",
                                                fontFamily: "sfprobold",
                                                color: "#403679",
                                                fontSize: "16px",
                                                padding: '5px',
                                                background: "#f8af24",
                                                // Padding for the capsule
                                                borderRadius: '50px', // Capsule shape
                                                // Capsule background with yellow and blue gradient
                                                // Makes it behave like a button
                                                textAlign: 'center', // Center-aligns the text
                                                cursor: 'pointer', // Indicates clickability
                                                border: '2px solid blue', // Optional: blue border for emphasis
                                            }}>
                                                {"beta"}
                                            </Button> */}
                                            <div style={{ marginTop: "10px" }}>
                                                <label style={{
                                                    fontFamily: "sfproregular", color: "white", fontSize: "18px", lineHeight: "28px", whiteSpace: 'pre-wrap', maxLines: "2", overflow: 'hidden', // To prevent overflow beyond 2 lines
                                                    textAlign: 'justify'
                                                }}>
                                                    {"Pre-built Audiences for Facebook Marketing."}
                                                </label>
                                                {/* <label style={{
                                                    fontFamily: "sfproregular", color: "#0766ff", fontSize: "18px", lineHeight: "28px", whiteSpace: 'pre-wrap', maxLines: "2", overflow: 'hidden', // To prevent overflow beyond 2 lines
                                                    textAlign: 'justify'
                                                }}>
                                                    Facebook &nbsp;
                                                </label> */}
                                                {/* <label style={{
                                                    fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", lineHeight: "28px", whiteSpace: 'pre-wrap', maxLines: "2", overflow: 'hidden', // To prevent overflow beyond 2 lines
                                                    textAlign: 'justify'
                                                }}>
                                                    {"Ad manager in one click upload."}
                                                </label> */}

                                            </div>



                                            {/* ///second content */}
                                            <div>
                                                <div className='mt-4'>
                                                    <label style={{
                                                        fontFamily: "sfprobold", color: "white", fontSize: "18px", lineHeight: "28px", whiteSpace: 'pre-wrap', maxLines: "2", overflow: 'hidden', // To prevent overflow beyond 2 lines
                                                        textAlign: 'justify'
                                                    }}>
                                                        {"Choose from a wide range of ready-to-use audiences, such as:"}
                                                    </label>
                                                </div>
                                                <div style={{ marginTop: "10px" }}>
                                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "start", textAlign: "start" }}>
                                                        <img
                                                            src={'https://kr-shipmultichannel-mum.s3.ap-south-1.amazonaws.com/1/extra_images/cf9c7c77-1564-4471-bfda-f0cd7b6dbdb6.png'}
                                                            alt="Audience Icon"
                                                            style={{ marginRight: "10px" }}
                                                        />
                                                        <div>
                                                            <label style={{
                                                                fontFamily: "sfprobold",
                                                                color: "#ffffff", // Corrected color code
                                                                fontSize: "16px",
                                                                whiteSpace: 'pre-wrap',
                                                                textAlign: 'center'  // Center text alignment
                                                            }}>
                                                                Active buyers (1 Cr+)
                                                            </label>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "start", textAlign: "start" }}>
                                                    <img src={"https://kr-shipmultichannel-mum.s3.ap-south-1.amazonaws.com/1/extra_images/bae200fe-2d2c-4e9f-b6ed-11802b4d51f3.png"} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div>
                                                        <label style={{
                                                            fontFamily: "sfprobold",
                                                            color: "#fffff",
                                                            fontSize: "16px",
                                                            whiteSpace: 'pre-wrap',
                                                            textAlign: 'justify'
                                                        }}>
                                                            Prepaid buyers (50 Lac+)
                                                        </label>


                                                    </div>
                                                </div>

                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "start", textAlign: "start" }}>
                                                    <img src={"https://kr-shipmultichannel-mum.s3.ap-south-1.amazonaws.com/1/extra_images/ca67d869-a0b1-4d3f-9315-124c8b578727.png"} alt="Audience Icon" style={{ marginRight: "10px", width: "55px", height: "45px", paddingLeft: "8px" }} />
                                                    <div>
                                                        <label style={{
                                                            fontFamily: "sfprobold",
                                                            color: "#fffff",
                                                            fontSize: "16px",
                                                            whiteSpace: 'pre-wrap',
                                                            textAlign: 'justify'
                                                        }}>
                                                            Low RTO Buyers (30 Lac+) ...and many more
                                                        </label>


                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "wrap", // Enables wrapping
                                                        alignItems: "center",
                                                        justifyContent: "start", // Center the content when it wraps
                                                        marginTop: "20px",
                                                        width: "75%", // Full width container

                                                        paddingRight: "20px" // Spacing around the div
                                                    }}
                                                >
                                                    <label
                                                        style={{

                                                            marginBottom: "2%",
                                                            fontFamily: "sfpromedium",
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: '5px 10px', // Padding for better spacing
                                                            background: "#C7FFCF",
                                                            borderRadius: '20px', // Capsule shape
                                                            cursor: 'pointer', // Clickable cursor
                                                            border: '1px solid', // Blue border for emphasis
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            // flexWrap: "wrap", // Ensures content wraps when needed
                                                            maxWidth: '100%', // Prevents overflow
                                                            textAlign: "start", // Center-aligns text in smaller screens
                                                        }}
                                                    >
                                                        <img
                                                            src={"https://kr-multichannel.s3.ap-southeast-1.amazonaws.com/1/extra_images/63f5bb53-cb83-42e8-bf55-527596c337be.png"}
                                                            alt="Audience Icon"
                                                            style={{
                                                                marginRight: "10px",
                                                                flexShrink: 0, // Prevents image from shrinking
                                                                maxWidth: '100%', // Ensures the image scales with screen size
                                                            }}
                                                        />
                                                        <span>
                                                            {"Connect with Facebook to get Free Audience worth Rs 2999 free"}
                                                            {/* <strong>{"FREE"} </strong>
                                                            {" Access to 2 Premium Audiences"} &nbsp;
                                                            <strong>{"worth Rs 4999 each!"}</strong> &nbsp;
                                                            {""} &nbsp; */}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className='mt-1' >
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                                                    <button
                                                        onClick={handleOpenDialog}
                                                        style={{
                                                            background: "#735AE5",
                                                            border: "1px solid #00000000",
                                                            borderRadius: "8px",
                                                            opacity: 1,
                                                            padding: "10px 20px",
                                                            color: "#FFFFFF",
                                                            cursor: "pointer",
                                                            fontSize: "16px",
                                                            fontWeight: "300",
                                                            fontFamily: "sfpromedium",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            marginTop: "20px",
                                                            width: is_active ? "auto" : '235px',
                                                            marginRight: "15px",  // Add spacing here
                                                        }}
                                                    >
                                                        <a
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            style={{ textDecoration: "none", color: "inherit" }}
                                                        >
                                                            {selectedAccountId == null ? "Connect with Facebook" : "Open Audience Center"}

                                                        </a>
                                                    </button>

                                                </div>

                                                {is_active ? (
                                                    <div style={{ marginTop: "1px", }}>
                                                        <div style={{ display: "flex" }}>
                                                            <label style={{
                                                                fontFamily: "sfproregular",
                                                                color: "#fffff",
                                                                fontSize: "16px",
                                                                marginTop: "10px",


                                                                cursor: "pointer", // To indicate it's clickable
                                                                // To make it look like a link
                                                            }}
                                                                onClick={handleFaqClick} // API call on click
                                                            >
                                                                <div style={{ display: "flex", marginLeft: "0px" }}>
                                                                    <span style={{ color: 'grey', marginRight: "10px" }}>{"Check FAQ's "}</span>
                                                                </div>
                                                            </label>
                                                        </div>

                                                    </div>

                                                ) : <div className='mt-3'>
                                                    <label style={{
                                                        fontFamily: "sfproregular",
                                                        color: "#fffff",
                                                        fontSize: "16px",
                                                        cursor: "pointer"
                                                    }}
                                                        onClick={handleFaqClick} // API call on click
                                                    >
                                                        <span style={{ color: 'grey' }}>{"Check FAQ's"}</span>
                                                    </label>
                                                </div>
                                                }

                                            </div>
                                        </div>
                                    </div>

                                </div>
                                {/* ///second frame */}
                                <div className='pl-14 pt-14' style={{ background: "#f8fafe", height: "500px" }}>
                                    <div style={{ display: "flex", gap: "40px" }}>
                                        <div className=' pl-10'>
                                            <img src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1725866240_Frame 7.jpg'} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                        </div>
                                        <div>
                                            <div style={{ width: "90%" }}>
                                                <label style={{ fontFamily: "sfprobold", color: "#010214", fontSize: "38px" }}>
                                                    About &nbsp;
                                                </label>
                                                <label style={{
                                                    fontFamily: "sfprobold",
                                                    color: "white",
                                                    fontSize: "38px",
                                                    background: 'linear-gradient(120.73deg, #5A27BA 11.29%, #C3A3FF 94.82%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {"Shiprocket Audience Pro "}
                                                </label>
                                                <Button style={{
                                                    marginBottom: "2%",
                                                    fontFamily: "sfprobold",

                                                    fontSize: "16px",
                                                    padding: '5px',
                                                    background: "#f8af24",
                                                    color: "#403679",

                                                    // Padding for the capsule
                                                    borderRadius: '50px', // Capsule shape
                                                    // Capsule background with yellow and blue gradient
                                                    // Makes it behave like a button
                                                    textAlign: 'center', // Center-aligns the text
                                                    cursor: 'pointer', // Indicates clickability
                                                    border: '2px solid blue', // Optional: blue border for emphasis
                                                }}>
                                                    {"beta"}
                                                </Button>

                                                <div style={{ marginTop: "20px", width: "600px" }}>
                                                    <label style={{ fontFamily: "sfproregular", color: "#646464", fontSize: "16px", whiteSpace: 'pre-wrap', }}>
                                                        {"Shiprocket Audience Pro is an AI product which adds new growth to the brands by allowing them to save time, cost with their audience planning and increase revenue by providing relevant audience segments with precise targeting and superior marketing performance."}   </label>
                                                </div>

                                                <div style={{ marginTop: "20px" }}>
                                                    <label style={{ fontFamily: "sfprobold", color: "#0766ff", fontSize: "28px" }}>
                                                        Facebook &nbsp;
                                                    </label>
                                                    <label style={{

                                                        fontFamily: "sfprobold",
                                                        color: "white",
                                                        fontSize: "28px",
                                                        background: 'linear-gradient(120.73deg, #5A27BA 11.29%, #C3A3FF 94.82%)',
                                                        WebkitTextFillColor: 'transparent',
                                                        WebkitBackgroundClip: 'text',
                                                    }}>
                                                        {"pe Jao, Campaign lagao and Shiprocket AudiencePro se Kamao."}
                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ///Third frame */}
                                <div style={{ background: "white", padding: "20px 100px" }}>
                                    <div >

                                        <div>
                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{
                                                    fontFamily: "sfpromedium",
                                                    color: "white",
                                                    fontSize: "38px",
                                                    background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {"  Enhance "}
                                                </label>
                                                <label style={{ fontFamily: "sfprobold", color: "#010214", fontSize: "38px" }}>
                                                    Your Marketing Campaigns &nbsp;
                                                </label>

                                                <div style={{ marginTop: "20px", }}>
                                                    <label
                                                        style={{
                                                            fontFamily: "sfproregular",
                                                            color: "#646464",
                                                            fontSize: "16px",
                                                            paddingRight: "20px",
                                                            whiteSpace: 'pre-wrap',
                                                            display: 'block',
                                                            lineHeight: "1.5", // For better readability
                                                        }}
                                                    >
                                                        {"With Shiprocket Audience Pro, you can leverage advanced data analytics to create precise and effective marketing campaigns. Our AI-segmented audiences are designed to minimize your cost & time to reach the right audience for your brand."}
                                                    </label>
                                                </div>

                                            </div>
                                        </div>

                                        <div className='flex gap-56' >
                                            <div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Increased ROI from your Facebook Ad manager"}
                                                            </label>
                                                            <div style={{ marginTop: "5px", width: "450px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                    {"Achieve superior return on ad spend (ROAS) through optimized audience targeting."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Reach large user base"}
                                                            </label>
                                                            <div style={{ marginTop: "5px", width: "450px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                    {" Unlock new growth for your business with a wide range of AI segmented ready to use audience’s."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Focussed Targeting"}
                                                            </label>
                                                            <div style={{ marginTop: "5px", width: "450px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                    {"Let data do your targeting with precision and accuracy and focus more on creating the best ads for your audience."}.
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Seamless Integration"}
                                                            </label>
                                                            <div style={{ marginTop: "5px", width: "450px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                    {" Integrate Shiprocket Audience Pro seamlessly with Facebook/Insta Marketing & with more channels coming soon ( Engage 360 )."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className=' pr-10 ' >
                                                <img src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1724917463_framebg3.png'} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ///Fourth frame */}
                                <div style={{ background: "#111026", padding: "10px 100px" }}>
                                    <div className='pt-10'>

                                        <div >
                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{
                                                    fontFamily: "sfpromedium",
                                                    color: "white",
                                                    fontSize: "38px",
                                                    background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {"Why Choose "}
                                                </label>
                                                <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "38px" }}>
                                                    Shiprocket Audience Pro? &nbsp;
                                                </label>





                                            </div>
                                        </div>

                                        <div className='flex  pb-10' style={{ justifyContent: "normal", gap: "20%" }} >
                                            <div style={{ marginTop: "20px", width: "258px" }}>
                                                <div >
                                                    <img src={f1} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div className='mt-5'>
                                                        <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "24px", whiteSpace: 'pre-wrap' }}>
                                                            {" Data + AI user segments"}
                                                        </label>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", whiteSpace: 'pre-wrap' }}>
                                                                {"Our AI segments use over 100+ user attributes to prioritize accuracy and precision in your Targeting."}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "20px", width: "258px" }}>
                                                <div >
                                                    <img src={f2} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div className='mt-5'>
                                                        <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "24px", whiteSpace: 'pre-wrap' }}>
                                                            {"From Idea to campaign in no time "}
                                                        </label>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", whiteSpace: 'pre-wrap' }}>
                                                                {"Our regularly updated segments ensure that you can go from Idea to campaign in one click upload."}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "20px", width: "258px" }}>
                                                <div >
                                                    <img src={f3} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div className='mt-5'>
                                                        <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "24px", whiteSpace: 'pre-wrap' }}>
                                                            {"Regularly updated Segments"}
                                                        </label>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", whiteSpace: 'pre-wrap' }}>
                                                                {"Our AI segments are regularly updated with the latest user information to ensure your targeting is always relevant."}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div ref={faqsRef}>
                                    <AudienceFaqs />
                                </div>
                                {/* ///Fifth frame */}
                                <div className='audiencebottom pl-14'>
                                    <div >
                                        <div style={{}}>

                                            <label style={{ fontFamily: "sfprobold", color: "#0B0757", fontSize: "38px" }}>
                                                {"Join For Free!"}
                                            </label>

                                        </div>

                                    </div>


                                    <div className='w-2/4' style={{ textAlign: "center" }}>
                                        <label style={{ fontFamily: "sfproregular", color: "#646464", fontSize: "14px", whiteSpace: 'pre-wrap', maxLines: "2" }}>
                                            {"Experience the future of marketing optimization with Shiprocket Audience Pro. "}
                                        </label>
                                    </div>
                                    <div className='mt-5' >
                                        <div>

                                            {<button
                                                onClick={handleOpenDialog}
                                                style={{
                                                    background: "#735AE5",
                                                    border: "1px solid #00000000",
                                                    borderRadius: "8px",
                                                    opacity: 1,
                                                    padding: "10px 20px",
                                                    color: "#FFFFFF",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                    fontWeight: "300",
                                                    fontFamily: "sfpromedium",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    marginTop: "20px",
                                                    width: is_active ? "auto" : '235px',
                                                    marginRight: "10px"
                                                }}
                                            >
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ textDecoration: "none", color: "inherit" }}
                                                >
                                                    {selectedAccountId == null ? "Join for Free" : "Explore Audiences"}
                                                </a>
                                            </button>}

                                        </div>
                                    </div>
                                </div>
                                {/* <AudiencePopUp
                                    open={dialogOpen}
                                    onClose={handleCloseDialog}
                                    onError={handleContactusError} // Pass error handler
                                    setIsActive={(isActive) => dispatch(setIsActive(isActive))} // Pass down the dispatch function
                                /> */}
                            </div>
                        ) : (
                            <div className="audienceMobileOrTablet">
                                {/* New content for tablet or mobile view */}
                                <div className="pt-20 mobile-audienceTop  mobileViewContent  ">
                                    <div>
                                        <label style={{ fontFamily: "sfprobold", color: "white", fontSize: "38px" }}>
                                            Boost Your ROAS &nbsp;
                                        </label>
                                        <label style={{
                                            fontFamily: "sfprobold",
                                            color: "white",
                                            fontSize: "38px",
                                            background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                                            WebkitTextFillColor: 'transparent',
                                            WebkitBackgroundClip: 'text',
                                        }}>
                                            {/* {"AI Tailored Audiences "} */}
                                        </label>


                                        <div style={{ marginTop: "10px" }}>
                                            <label style={{
                                                fontFamily: "sfproregular", color: "white", fontSize: "18px", lineHeight: "28px", whiteSpace: 'pre-wrap', maxLines: "2", overflow: 'hidden', // To prevent overflow beyond 2 lines
                                                textAlign: 'justify'
                                            }}>
                                                {"Pre-built Audiences for Facebook Marketing."}
                                            </label>
                                        </div>
                                        {/* ///second content */}
                                        <div>

                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{
                                                    fontFamily: "sfprobold", color: "white", fontSize: "18px", lineHeight: "28px", whiteSpace: 'pre-wrap', maxLines: "2", overflow: 'hidden', // To prevent overflow beyond 2 lines
                                                    textAlign: 'justify'
                                                }}>
                                                    {"Choose from a wide range of ready-to-use\n audiences, such as:"}
                                                </label>
                                            </div>

                                            <div style={{ marginTop: "20px" }}>
                                                <div style={{ display: "flex", alignItems: "center", justifyContent: "start", textAlign: "start" }}>
                                                    <img
                                                        src={'https://kr-shipmultichannel-mum.s3.ap-south-1.amazonaws.com/1/extra_images/cf9c7c77-1564-4471-bfda-f0cd7b6dbdb6.png'}
                                                        alt="Audience Icon"
                                                        style={{ marginRight: "10px" }}
                                                    />
                                                    <div>
                                                        <label style={{
                                                            fontFamily: "sfprobold",
                                                            color: "#ffffff", // Corrected color code
                                                            fontSize: "16px",
                                                            whiteSpace: 'pre-wrap',
                                                            textAlign: 'center'  // Center text alignment
                                                        }}>
                                                            Active buyers (1 Cr+)
                                                        </label>
                                                    </div>
                                                </div>
                                                <div style={{ display: "flex", alignItems: "center", marginTop: "20px", justifyContent: "start", textAlign: "start" }}>
                                                    <img src={"https://kr-shipmultichannel-mum.s3.ap-south-1.amazonaws.com/1/extra_images/bae200fe-2d2c-4e9f-b6ed-11802b4d51f3.png"} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div>
                                                        <label style={{
                                                            fontFamily: "sfprobold",
                                                            color: "#fffff",
                                                            fontSize: "16px",
                                                            whiteSpace: 'pre-wrap',
                                                            textAlign: 'justify'
                                                        }}>
                                                            Prepaid buyers (50 Lac+)
                                                        </label>


                                                    </div>
                                                </div>

                                                <div style={{ display: "flex", alignItems: "center", marginTop: "20px", justifyContent: "start", textAlign: "start" }}>
                                                    <img src={"https://kr-shipmultichannel-mum.s3.ap-south-1.amazonaws.com/1/extra_images/ca67d869-a0b1-4d3f-9315-124c8b578727.png"} alt="Audience Icon" style={{ marginRight: "10px", width: "55px", height: "45px", paddingLeft: "8px" }} />
                                                    <div>
                                                        <label style={{
                                                            fontFamily: "sfprobold",
                                                            color: "#fffff",
                                                            fontSize: "16px",
                                                            whiteSpace: 'pre-wrap',
                                                            textAlign: 'justify'
                                                        }}>
                                                            Low RTO Buyers (30 Lac+) ...and many more
                                                        </label>


                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexWrap: "wrap", // Enables wrapping
                                                        alignItems: "center",
                                                        justifyContent: "start", // Center the content when it wraps
                                                        marginTop: "20px",
                                                        width: "100%", // Full width container

                                                        paddingRight: "20px" // Spacing around the div
                                                    }}
                                                >
                                                    <label
                                                        style={{

                                                            marginBottom: "2%",
                                                            fontFamily: "sfpromedium",
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: '5px 10px', // Padding for better spacing
                                                            background: "#C7FFCF",
                                                            borderRadius: '20px', // Capsule shape
                                                            cursor: 'pointer', // Clickable cursor
                                                            border: '1px solid', // Blue border for emphasis
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            // flexWrap: "wrap", // Ensures content wraps when needed
                                                            maxWidth: '100%', // Prevents overflow
                                                            textAlign: "start", // Center-aligns text in smaller screens
                                                        }}
                                                    >
                                                        <img
                                                            src={"https://kr-multichannel.s3.ap-southeast-1.amazonaws.com/1/extra_images/63f5bb53-cb83-42e8-bf55-527596c337be.png"}
                                                            alt="Audience Icon"
                                                            style={{
                                                                marginRight: "10px",
                                                                flexShrink: 0, // Prevents image from shrinking
                                                                maxWidth: '100%', // Ensures the image scales with screen size
                                                            }}
                                                        />
                                                        <span>
                                                            {"Connect with Facebook to get Free Audience worth Rs 2999 free"}
                                                            {/* <strong>{"FREE"} </strong>
                                                            {" Access to 2 Premium Audiences"} &nbsp;
                                                            <strong>{"worth Rs 4999 each!"}</strong> &nbsp;

                                                            {""} &nbsp; */}
                                                        </span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='mt-5 text-center'>
                                            <button
                                                onClick={handleOpenDialog}
                                                style={{
                                                    background: "#735AE5",
                                                    border: "1px solid #00000000",
                                                    textAlign: "center",
                                                    borderRadius: "8px",
                                                    opacity: 1,
                                                    padding: "10px 20px",
                                                    color: "#FFFFFF",
                                                    cursor: "pointer",
                                                    fontSize: "16px",
                                                    fontWeight: "300",
                                                    fontFamily: "sfpromedium",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    alignSelf: "center",
                                                    marginTop: "20px",
                                                    width: is_active ? 'auto' : "235px",
                                                    marginRight: "10px"
                                                }}
                                            >
                                                <a
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ textDecoration: "none", color: "inherit" }}>

                                                    {selectedAccountId == null ? "Connect with Facebook" : "Open Audience Center"}
                                                </a>
                                            </button>

                                        </div>
                                        {is_active ? (
                                            <div style={{ marginTop: "1px", }}>
                                                <div style={{ display: "flex" }}>
                                                    <label style={{
                                                        fontFamily: "sfproregular",
                                                        color: "#fffff",
                                                        fontSize: "16px",
                                                        marginTop: "10px",


                                                        cursor: "pointer", // To indicate it's clickable
                                                        // To make it look like a link
                                                    }}
                                                        onClick={handleFaqClick} // API call on click
                                                    >
                                                        <div style={{ display: "flex", marginLeft: "0px" }}>
                                                            <span style={{ color: 'grey', marginRight: "10px" }}>{"Check FAQ's "}</span>

                                                        </div>
                                                    </label>
                                                    <label style={{
                                                        fontFamily: "sfproregular",
                                                        color: "#fffff",
                                                        fontSize: "16px",
                                                        marginTop: "10px",


                                                        cursor: "pointer", // To indicate it's clickable
                                                        // To make it look like a link
                                                    }}
                                                        onClick={handleClick} // API call on click
                                                    >
                                                        <div style={{ display: "flex", marginLeft: "0px" }}>



                                                            <span style={{ color: 'grey', marginLeft: "10px" }}>{" Get in Touch"}</span>
                                                        </div>
                                                    </label>
                                                </div>
                                                <div className='mt-2'>
                                                    <label style={{
                                                        fontFamily: "sfproregular",
                                                        color: "#fffff",

                                                        fontSize: "16px",
                                                        cursor: "pointer", // To indicate it's clickable
                                                        // To make it look like a link
                                                    }}
                                                    // API call on click
                                                    >Your Audience has been successfully shared to your Facebook Meta account.
                                                    </label>
                                                </div>

                                            </div>

                                        ) : <div className='mt-2' style={{ textAlign: "center" }}>
                                            <label style={{
                                                fontFamily: "sfproregular",
                                                color: "#fffff",
                                                fontSize: "16px",


                                                cursor: "pointer", // To indicate it's clickable
                                                // To make it look like a link
                                            }}
                                                onClick={handleFaqClick} // API call on click
                                            >
                                                <span style={{ color: 'grey' }}>{"Check FAQ's"}</span>
                                            </label>
                                        </div>
                                        }
                                        <div style={{ height: "70vh" }} className='mt-9'>
                                            {/* ///hide img for mob view */}
                                            <img src={tabtop} />

                                        </div>
                                    </div>

                                </div>
                                {/* ///secondFrame */}
                                <div className='p-5' style={{ background: "#f8fafe", height: "auto" }}>
                                    <div >

                                        <div >
                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{ fontFamily: "sfprobold", color: "#010214", fontSize: "38px" }}>
                                                    About &nbsp;
                                                </label>
                                                <label style={{
                                                    fontFamily: "sfprobold",
                                                    color: "white",
                                                    fontSize: "38px",
                                                    background: 'linear-gradient(120.73deg, #5A27BA 11.29%, #C3A3FF 94.82%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {"Shiprocket Audience Pro (beta)"}
                                                </label>

                                                <div style={{ marginTop: "20px", }}>
                                                    <label style={{ fontFamily: "sfproregular", color: "#646464", fontSize: "16px", whiteSpace: 'pre-wrap', maxLines: "2" }}>
                                                        {"Shiprocket Audience Pro is an AI product which adds new growth to the brands by allowing them to save time, cost with their audience planning and increase revenue by providing relevant audience segments with precise targeting and superior marketing performance."}   </label>
                                                </div>


                                            </div>
                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{ fontFamily: "sfprobold", color: "#0766ff", fontSize: "22px" }}>
                                                    Facebook &nbsp;
                                                </label>
                                                <label style={{

                                                    fontFamily: "sfprobold",
                                                    color: "white",
                                                    fontSize: "28px",
                                                    background: 'linear-gradient(120.73deg, #5A27BA 11.29%, #C3A3FF 94.82%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {"pe Jao, Campaign lagao and Shiprocket AudiencePro se Kamao."}
                                                </label>
                                            </div>
                                        </div>
                                        <div className='pt-5 text-center'>
                                            <img src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1724917598_frameBg2.png'} alt="Audience Icon" />

                                        </div>

                                    </div>
                                </div>

                                {/* ///Third frame */}
                                <div className='pt-12 p-10' style={{ background: "white", }}>
                                    <div >

                                        <div>
                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{
                                                    fontFamily: "sfpromedium",
                                                    color: "white",
                                                    fontSize: "38px",
                                                    background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {" Enhance "}
                                                </label>
                                                <label style={{ fontFamily: "sfprobold", color: "#010214", fontSize: "38px" }}>
                                                    Your Marketing Campaigns &nbsp;
                                                </label>
                                                <div style={{ marginTop: "20px" }}>
                                                    <label
                                                        style={{
                                                            fontFamily: "sfproregular",
                                                            color: "#646464",
                                                            fontSize: "14px",
                                                            whiteSpace: 'pre-wrap',
                                                            display: 'block',
                                                            lineHeight: "1.5", // For better readability
                                                        }}
                                                    >
                                                        {"With Shiprocket Audience Pro, you can leverage advanced data analytics to create precise and effective marketing campaigns. Our AI-segmented audiences are designed to minimize your cost & time to reach the right audience for your brand."}
                                                    </label>
                                                </div>

                                            </div>
                                        </div>

                                        <div  >
                                            <div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Increased ROI from your Facebook Ad manager"}
                                                            </label>
                                                            <div style={{ marginTop: "5px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "14px", whiteSpace: 'pre-wrap' }}>
                                                                    {" Achieve superior return on ad spend (ROAS) through optimized audience targeting."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Reach large user base"}
                                                            </label>
                                                            <div style={{ marginTop: "5px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "14px", whiteSpace: 'pre-wrap' }}>
                                                                    {"Unlock new growth for your business with a wide range of AI segmented ready to use audience’s."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Focussed Targeting"}
                                                            </label>
                                                            <div style={{ marginTop: "5px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "14px", whiteSpace: 'pre-wrap' }}>
                                                                    {" Let data do your targeting with precision and accuracy and focus more on creating the best ads for your audience."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: "20px" }}>
                                                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                                                        <img src={rectangleFrame} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                        <div>
                                                            <label style={{ fontFamily: "sfprobold", color: "#283465", fontSize: "16px", whiteSpace: 'pre-wrap' }}>
                                                                {"Seamless Integration"}
                                                            </label>
                                                            <div style={{ marginTop: "5px" }}>
                                                                <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "14px", whiteSpace: 'pre-wrap' }}>
                                                                    {" Integrate Shiprocket Audience Pro seamlessly with Facebook/Insta Marketing & with more channels coming soon ( Engage 360 )."}
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='text-center'>
                                                <img src={'https://s3-ap-south-1.amazonaws.com/kr-shipmultichannel-mum/appstore/app_1724917463_framebg3.png'} alt="Audience Icon" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ///Fourth frame */}
                                <div className='pl-14' style={{ background: "#111026", }}>
                                    <div className='pt-10'>

                                        <div >
                                            <div style={{ marginTop: "20px" }}>
                                                <label style={{
                                                    fontFamily: "sfpromedium",
                                                    color: "white",
                                                    fontSize: "38px",
                                                    background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
                                                    WebkitTextFillColor: 'transparent',
                                                    WebkitBackgroundClip: 'text',
                                                }}>
                                                    {"Why Choose "}
                                                </label>
                                                <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "38px" }}>
                                                    Shiprocket Audience Pro? &nbsp;
                                                </label>





                                            </div>
                                        </div>

                                        <div className='pr-10 pt-10 pb-10' style={{ justifyContent: "space-between" }} >
                                            <div style={{ marginTop: "20px", width: "258px" }}>
                                                <div >
                                                    <img src={f1} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div className='mt-5'>
                                                        <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "24px", whiteSpace: 'pre-wrap' }}>
                                                            {"Data + AI user segments"}
                                                        </label>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", whiteSpace: 'pre-wrap' }}>
                                                                {"Our AI segments use over 100+ user attributes to prioritize accuracy and precision in your Targeting."}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "20px", width: "258px" }}>
                                                <div >
                                                    <img src={f2} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div className='mt-5'>
                                                        <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "24px", whiteSpace: 'pre-wrap' }}>
                                                            {"From Idea to campaign in no time "}
                                                        </label>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", whiteSpace: 'pre-wrap' }}>
                                                                {"Our regularly updated segments ensure that you can go from Idea to campaign in one click upload."} </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: "20px", width: "258px" }}>
                                                <div >
                                                    <img src={f3} alt="Audience Icon" style={{ marginRight: "10px" }} />
                                                    <div className='mt-5'>
                                                        <label style={{ fontFamily: "sfprobold", color: "#fff", fontSize: "24px", whiteSpace: 'pre-wrap' }}>
                                                            {"Regularly updated Segments"}
                                                        </label>
                                                        <div style={{ marginTop: "5px" }}>
                                                            <label style={{ fontFamily: "sfproregular", color: "#ACACAC", fontSize: "18px", whiteSpace: 'pre-wrap' }}>
                                                                {"Our AI segments are regularly updated with the latest user information to ensure your targeting is always relevant."}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div ref={faqsRef}>
                                    <AudienceFaqs />
                                </div>
                                {/* ///Fifth frame */}
                                <div className='audiencebottom pl-14'>
                                    <div >
                                        <div style={{}}>

                                            <label style={{ fontFamily: "sfprobold", color: "#0B0757", fontSize: "38px" }}>
                                                {"Join For Free!"}
                                            </label>

                                        </div>

                                    </div>


                                    <div className='w-2/4 mt-8' style={{ textAlign: "center" }}>
                                        <label style={{ fontFamily: "sfproregular", color: "#646464", fontSize: "14px", whiteSpace: 'pre-wrap', maxLines: "2" }}>
                                            {"Experience the future of marketing optimization with Shiprocket Audience Pro. "}   </label>
                                    </div>
                                    <div className='mt-5'>
                                        {<button
                                            onClick={handleOpenDialog}
                                            style={{
                                                background: "#735AE5",
                                                border: "1px solid #00000000",
                                                borderRadius: "8px",
                                                opacity: 1,
                                                padding: "10px 20px",
                                                color: "#FFFFFF",
                                                cursor: "pointer",
                                                fontSize: "16px",
                                                fontWeight: "300",
                                                fontFamily: "sfpromedium",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                marginTop: "20px",
                                                width: is_active ? "auto" : "235px",
                                            }}
                                        >
                                            <a
                                                target="_blank"
                                                rel="noreferrer"
                                                style={{ textDecoration: "none", color: "inherit" }}
                                            >
                                                {selectedAccountId == null ? "Join for Free" : "Explore Audiences"}
                                            </a>
                                        </button>}

                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Other components remain unchanged */}

                        {/* <AudiencePopUp
                            open={dialogOpen}
                            onClose={handleCloseDialog}
                            onError={handleContactusError}
                            setIsActive={(isActive) => dispatch(setIsActive(isActive))} // Pass down the dispatch function
                        /> */}

                    </div>
                </div>
            </div>
        </>
    )
}


